import React, { useContext, useEffect, useState } from 'react'
import { styled } from '@mui/material/styles'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell, { tableCellClasses } from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import Button from '@mui/material/Button'
import Tooltip from '@mui/material/Tooltip'
import CircularProgress from '@mui/material/CircularProgress'
import Box from '@mui/material/Box'
import FileDownloadIcon from '@mui/icons-material/FileDownload'

// moment
import moment from 'moment'
import { ReportContext } from '../../../providers/report'
import 'moment/locale/pt-br'

moment.locale('pt-br')

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#ccd219',
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}))

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}))

const REPORT_TAB_MAP = {
  'Relatório de Pacote': 'pacotes',
  'Relatório de Pet': 'pets',
  'Relatório de Cliente': 'clientes',
  'Relatório de Agendamento': 'agendamentos',
}

function Downloads({ setValue }) {
  const { getDownloads, downloads } = useContext(ReportContext)
  const [loading, setLoading] = useState(false)

  const handleDownloadClick = (file) => {
    if (!file) return
    window.open(file, '_blank', 'noopener,noreferrer')
  }

  useEffect(() => {
    const fetchDownloads = async () => {
      setLoading(true)
      await getDownloads()
      setLoading(false)
    }
    fetchDownloads()
  }, [])

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight={200}>
        <CircularProgress style={{ color: '#ccd219' }} />
      </Box>
    )
  }

  return (
    <TableContainer component={Paper} style={{ marginTop: '15px' }}>
      <Table sx={{ minWidth: 700 }} aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell>Nome</StyledTableCell>
            <StyledTableCell align="left">Status</StyledTableCell>
            <StyledTableCell align="left">Solicitação</StyledTableCell>
            <StyledTableCell align="left">Finalização</StyledTableCell>
            <StyledTableCell align="center">Relatório</StyledTableCell>
            <StyledTableCell align="center">Arquivo</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {downloads?.map((row) => {
            const finalizado = row.status === 'FINALIZADO'
            return (
              <StyledTableRow key={row.name}>
                <StyledTableCell component="th" scope="row">
                  {row.name}
                </StyledTableCell>
                <StyledTableCell align="left">{row.status}</StyledTableCell>
                <StyledTableCell align="left">
                  {moment(row.createdAt).format('DD-MM-YYYY')}
                </StyledTableCell>
                <StyledTableCell align="left">
                  {finalizado && moment(row.updatedAt).format('DD-MM-YYYY')}
                </StyledTableCell>
                <StyledTableCell align="center">
                  <Tooltip title={row.name} placement="left">
                    <Button
                      onClick={() => setValue(REPORT_TAB_MAP[row.name])}
                      style={{ color: '#ccd219' }}
                    >
                      Ver Relatório
                    </Button>
                  </Tooltip>
                </StyledTableCell>
                <StyledTableCell align="center">
                  <Tooltip
                    title={finalizado ? 'Baixar' : 'Disponível apenas após finalização'}
                    placement="left"
                  >
                    <span>
                      <Button
                        onClick={(e) => {
                          e.preventDefault()
                          if (!finalizado || !row.file) return
                          handleDownloadClick(row.file)
                        }}
                        disabled={!finalizado || !row.file}
                        style={{ pointerEvents: !finalizado || !row.file ? 'none' : 'auto' }}
                      >
                        <FileDownloadIcon style={{ color: finalizado && row.file ? '#ccd219' : '#ccc' }} />
                      </Button>
                    </span>
                  </Tooltip>
                </StyledTableCell>
              </StyledTableRow>
            )
          })}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default Downloads
